<template>
  <div id="app"
    @dragover.prevent
    @drop.prevent
  >
    <title>Philips Care Portal</title>
    <router-view v-on:forceUpdate="forceUpdate" :key="reset"/>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
export default {
  name: "App",
  methods: {
    loadingStart: function() {
      this.isLoading = true;
    },
    loadingEnd: function() {
      this.isLoading = false;
    },
    forceUpdate: function(){
      this.reset += 1;
    }
    
  },
  data() {
    return {
      reset: 0,
      isLoading: false
    };
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #061e57;
  height: 100%;
}
</style>
<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #061e57;
$primary-invert: findColorInvert($primary);
$info: #209cee;
$info-invert: findColorInvert($info);
$light: whitesmoke;
$light-invert: findColorInvert($light);
$success: #23d160;
$success-invert: findColorInvert($success);
$danger: #ff3860;
$danger-invert: #fff;
$pink: #ffc0cb;
$pink-invert: findColorInvert($pink);
$purple: #9370db;
$purple-invert: findColorInvert($purple);
$background: #199fae;

$blue1:#CBE6F3;
$blue2:#9ACDE7;
$blue3:#6EB7DB;
$blue4:#45A1CF;
$blue5:#208DC3;
$blue6:#007AB7;
$orange:#EF6C00;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "red": (
    $danger,
    $black
  ),
  "green": (
    $success,
    $black
  ),
  "yellow": (
    $warning,
    $black
  ),
  "pink": (
    $pink,
    $pink-invert
  ),
  "purple": (
    $purple,
    $black
  ),
  "blue": (
    $info,
    $black
  ),
  "blue1":(
    $blue1,
    $black
  ),
  "blue2":(
    $blue2,
    $black
  ),
  "blue3":(
    $blue3,
    $black
  ),
  "blue4":(
    $blue4,
    $white
  ),
  "blue5":(
    $blue5,
    $white
  ),
  "blue6":(
    $blue6,
    $white
  ),
  "orange":(
    $orange,
    $white
  )
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

$size-medium: $size-6;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

</style>

<style lang="scss">

@import '@/components/mock/base/base.scss';

</style>


// WEBPACK FOOTER //
// src/components/mock/App.vue